export default __webpack_public_path__ + "static/media/180524174552.b67b09e6.jpg";